<template>
  <div class="border">
    <el-dialog :fullscreen="true" top="200px" :visible.sync="ifshow"  @open="openDialog" :before-close="closeDialog">
      <el-row type="flex" style="margin-bottom: 20px;margin-top: -30px;">
        <el-col :span="24">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item>{{strategy.name}}[{{getLabelByValue('strategyStatus', strategy.status)}}]</el-breadcrumb-item>
            <el-breadcrumb-item>组件池</el-breadcrumb-item>
            <el-breadcrumb-item>{{(strategyItem.code ? ('[' + strategyItem.code + ']' + strategyItem.name) : '新增决策表')}}</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-form :inline="true" :model="decisionTreeForm" :rules="decisionTreeFormRules" ref="decisionTreeForm" label-width="60px">
        <el-row type="flex" :gutter="20">
          <el-col :span="19">
            <el-card class="box-card" shadow="never">
              <el-row type="flex">
                <el-col :span="21">
                  <el-form-item label="code" prop="code">
                    <el-input v-model="decisionTreeForm.code" placeholder="决策表编号" style="width: 400px;" :readonly="strategyItem.code && strategyItem.code !== ''" :class="{'decision-table': strategyItem.code}"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item style="float: right;">
                    <el-button type="success" size="small" @click="saveDecisionTable('decisionTreeForm')">保存</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="24">
                  <el-form-item label="名称" prop="name">
                    <el-input v-model="decisionTreeForm.name" placeholder="决策表名称" style="width: 400px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="24">
                  <el-form-item label="描述" prop="description">
                    <el-input type="textarea" rows="3" cols="150" v-model="decisionTreeForm.description"
                              placeholder="描述"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
            <el-row type="flex" style="margin-top: 30px;">
              <el-col :span="2">
                <el-button type="primary" size="mini" @click="addRow">新增一行</el-button>
              </el-col>
              <el-col :span="2">
                <el-button type="primary" size="mini" @click="inVisibleDialog = true">新增输入</el-button>
              </el-col>
              <el-col :span="2">
                <el-button type="primary"  size="mini" @click="outVisibleDialog = true">新增输出</el-button>
              </el-col>
            </el-row>
            <el-card class="box-card" shadow="never" style="margin-top: 5px;">
              <el-row type="flex">
                <el-col :span="12" >
                  <el-editable ref="putInTable" :data.sync="viewData.putInTableData" border stripe highlight-current-row>
                    <el-table-column
                      fixed="left"
                      label="操作"
                      width="60">
                      <template slot-scope="scope">
                        <el-button
                          @click.native.prevent="deleteRow(scope.$index)"
                          type="text"
                          size="small">
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                    <el-editable-column min-width="150" v-for="(val,i) in viewData.putInHeader" :key="i" :prop="val.prop" :label="val.label" editHeaderType="simple" show-overflow-tooltip class="decision-table"
                                         @removeColumn="removeInColumn(val.prop, i)"  :editRender="{name: 'ElMention', sources: val.variable}" @updateTargets="updateTargets">
                    </el-editable-column>
                  </el-editable>
                  <div style="text-align: center;height: 46px;line-height: 46px;border: 1px solid #ebeef5;border-top: none;background-color: #fafafa;font-size: 12px;color: #9e9399;">兜底结果</div>
                </el-col>
                <el-col :span="12" >
                      <el-editable ref="putOutTable" :data.sync="viewData.putOutTableData" border highlight-current-row :row-style="tableRowStyle">
                        <el-editable-column min-width="150" v-for="(val,i) in viewData.putOutHeader" :key="i" :prop="val.prop" :label="val.label" editHeaderType="simple" show-overflow-tooltip
                                             @removeColumn="removeOutColumn(val.prop, i)" :editRender="{name: 'ElMention', sources: variableSources}" @updateTargets="updateTargets">
                        </el-editable-column>
                      </el-editable>
                    </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="5">
            <el-card class="box-card test-card" style="height: 100%;">
              <div slot="header" class="clearfix">
                <span>输入测试</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="testExpression">测试</el-button>
              </div>
              <div class="text item">
                <div style="margin-bottom: 5px;display: flex;" v-for="(val, key, testIndex) in viewData.testData" :key="'testData.' + testIndex">
                  <span style="width: 60%;display: block;float: left;height: 40px;line-height: 40px;">{{key}}</span>
                  <el-input v-model="viewData.testData[key]" style="width: 40%;float: right"></el-input>
                </div>
                <div style="border: solid 1px #ccc3c3;width: 96%;height: 165px;margin-top: 30px;border-radius: 5px;padding: 10px;font-size: 15px;word-break: break-all;">
                  {{testResult}}
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
      <div style="height: 320px"></div>
    </el-dialog>
    <el-dialog
      title="选择输入"
      :visible.sync="inVisibleDialog"
      width="28%"
      append-to-body
      @open="initInVisible"
      :before-close="handleCloseInsertIn">
      <div>
        <tribute-mention :value.sync="inVariableInfo" :sources="variableSources">
        </tribute-mention>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="insertInVariable">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="新增输出"
      :visible.sync="outVisibleDialog"
      width="28%"
      append-to-body
      :before-close="handleClose">
      <el-form :inline="true" :rules="variableRules" :model="variableForm" ref="variableForm" class="demo-form-inline">
        <el-form-item label=" " prop="name">
          <el-input v-model="variableForm.name" placeholder="请输入变量名"></el-input>
        </el-form-item>
        <el-form-item label="变量类型" prop="dataType">
          <el-select style="width: 120px" v-model="variableForm.dataType" placeholder="变量类型">
            <el-option v-for="item in globalConfig.variableTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="outVisibleDialog = false">取 消</el-button>
        <el-button type="primary" @click="insertOutVariable('variableForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import debounce from 'throttle-debounce/debounce'
import Editable from '@/components/editable/Editable.vue'
import EditableColumn from '@/components/editable/EditableColumn.vue'
import TributeMention from '@/components/mention/tributeMention.vue'
import {clone, loadMentionSources} from '@/utils/common'

export default {
  props: {
    ifshow: Boolean,
    strategyItem: Object,
    strategy: Object
  },
  name: 'editor',
  data () {
    return {
      regex: new RegExp(`(?<=@)[sme].[a-zA-Z\\d_.]+(?=\\s)`, 'g'),
      inVariableInfo: {value: '', targets: []},
      variableSources: [],
      postData: {
        strategyId: this.strategy.id,
        id: this.strategyItem.id,
        name: null,
        code: null,
        type: 2,
        description: null,
        strategyItemOutputs: null,
        strategyRefVariables: null,
        expression: null,
        viewData: null
      },
      decisionTreeForm: {
        name: null,
        code: null,
        description: null
      },
      viewData: {
        // 策略组件输出变量
        strategyItemOutputsCheck: [
        ],
        // 策略引用变量
        // ref_id  ref_variable_type引用变量类型（1：策略自定义变量、2：策略组件输出变量、3：变量池变量） name
        strategyRefVariables: [
        ],
        putInTableData: [{id: 1}],
        putOutTableData: [{id: 1}, {id: 1}],
        putInHeader: [],
        putOutHeader: [],
        testData: {}
      },
      variableForm: {
        id: null,
        name: null,
        dataType: null
      },
      outVisibleDialog: false,
      inVisibleDialog: false,
      showAddFlag: false,
      variableRules: {
        variableName: [
          { required: true, message: '变量名不能为空', trigger: 'blur' }
        ],
        dataType: [
          { required: true, message: '变量类型不能为空', trigger: 'change' }
        ]
      },
      decisionTreeFormRules: {
        name: [
          { required: true, message: 'code不能为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      },
      testResult: '',
      viewDataJsonTemplate: {
        strategyItemOutputsCheck: [
        ],
        strategyRefVariables: [
        ],
        putInTableData: [{id: 1}],
        putOutTableData: [{id: 1}, {id: 1}],
        putInHeader: [],
        putOutHeader: [],
        testData: {}
      }
    }
  },
  created () {
  },
  methods: {
    initInVisible () {
      this.inVariableInfo = {value: '', targets: []}
    },
    async openDialog () {
      // 加载策略下所有变量源 并且排除当前组件的输出
      this.variableSources = await loadMentionSources.doLoadSourcesExcludeCurrentModelOutput(this.strategy.id, this.strategyItem.code)
      // 初始化data
      this.postData = {
        strategyId: this.strategy.id,
        id: this.strategyItem.id,
        name: null,
        code: null,
        type: 2,
        description: null,
        strategyItemOutputs: null,
        strategyRefVariables: null,
        expression: null,
        viewData: null
      }
      this.testResult = ''
      this.viewData = this.strategyItem.viewData ? JSON.parse(this.strategyItem.viewData) : clone(this.viewDataJsonTemplate)
      this.decisionTreeForm.code = this.strategyItem.code
      this.decisionTreeForm.name = this.strategyItem.name
      this.decisionTreeForm.description = this.strategyItem.description
    },
    updateTargets (targets) {
      // 迭代出所有数据
      let expression = ''
      let dataLength = this.viewData.putInTableData.length
      let inLength = this.viewData.putInHeader.length
      let outLength = this.viewData.putOutHeader.length
      for (let i = 0; i < dataLength; i++) {
        expression += '[ '
        for (let j = 0; j < inLength; j++) {
          let label = this.viewData.putInHeader[j].label
          let element = this.viewData.putInTableData[i][label]
          if (!element || !element.trim()) {
            continue
          }
          expression += ' ' + element + ' '
        }
        for (let k = 0; k < outLength; k++) {
          let label = this.viewData.putOutHeader[k].label
          let element = this.viewData.putOutTableData[i][label]
          if (!element || !element.trim()) {
            continue
          }
          expression += ' ' + label.trim() + ' ' + element.trim() + ' '
        }
      }
      // 兜底结果
      for (let k = 0; k < outLength; k++) {
        let label = this.viewData.putOutHeader[k].label
        let element = this.viewData.putOutTableData[dataLength][label]
        if (!element || !element.trim()) {
          continue
        }
        expression += ' ' + label.trim() + ' ' + element.trim() + ' '
      }
      let arr = expression.match(this.regex)
      if (arr) {
        let testData = {}
        if (arr && arr.length > 0) {
          for (let j of arr) {
            testData[this.replaceEMS('@' + j)] = null
          }
        }
        this.viewData.testData = testData
      }
    },
    closeDialog () {
      this.$emit('handleCloseDialog')
    },
    replaceEMS (str) {
      str = str.replace(/@s./g, 's_').replace(/@m./g, 'm_').replace(/@e./g, '')
        .replace(/[$]max/g, this.mvelConfig.actionOptions.max).replace(/[$]min/g, this.mvelConfig.actionOptions.min)
      return str
    },
    insertInVariable () {
      console.log(this.inVariableInfo)
      console.log(JSON.stringify(this.inVariableInfo))
      if (!this.inVariableInfo.targets || this.inVariableInfo.targets.length !== 1) {
        this.$message.error('必须且只能选择一个引用变量')
        return
      }
      // 设置初始空格
      this.viewData.putInTableData.forEach((item, i) => {
        item[this.inVariableInfo.value] = ''
      })
      this.addPutIn(this.inVariableInfo.value)
    },
    insertOutVariable (formName) {
      let blockSubmission = false // 阻止提交变量
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          blockSubmission = true
          return false
        }
      })
      // 校验不通过，返回
      if (blockSubmission) return
      // 校验重复输出变量
      for (const e of this.viewData.putOutHeader) {
        if (e.label === this.variableForm.name) {
          this.$message.error('输出变量名不能重复')
          return
        }
      }
      this.viewData.putOutHeader.push({
        label: this.variableForm.name,
        prop: this.variableForm.name
      })

      // 记录输出
      this.viewData.strategyItemOutputsCheck.push({
        name: this.variableForm.name,
        dataType: this.variableForm.dataType
      })
      // 设置初始空格
      this.viewData.putOutTableData.forEach((item, i) => {
        item[this.variableForm.name] = ''
      })
      this.$refs[formName].resetFields()
      this.outVisibleDialog = false
    },
    handleClose (done) {
      done()
    },
    handleCloseInsertIn (done) {
      done()
      this.inVariableInfo = {value: '', targets: []}
    },
    saveDecisionTable: debounce(300, async function (formName) {
      let blockSubmission// 阻止提交变量
      this.$refs[formName].validate((valid) => {
        blockSubmission = valid
      })
      if (!blockSubmission) {
        return
      }
      // 表达式校验 校验测试是否通过
      let testRes = await this.testExpression()
      if (!testRes) {
        return
      }
      // 初始化引用变量字段
      this.viewData.strategyRefVariables = []
      // 提取[s]引用变量
      let expression = this.postData.expression
      let refs = expression.match(this.regex)
      if (refs) {
        let targets = this.variableSources.filter(s => refs.find(o => o === s.value))
        targets.forEach(a => {
          this.viewData.strategyRefVariables.push({
            refId: a.id,
            refVariableType: a.refType,
            name: a.name
          })
        })
      }
      this.postData.expression = this.replaceEMS(expression)
      this.postData.viewData = JSON.stringify(this.viewData)
      this.postData.name = clone(this.decisionTreeForm.name)
      this.postData.code = clone(this.decisionTreeForm.code)
      this.postData.description = this.decisionTreeForm.description
      // 输出变量名拼上code
      this.postData.strategyItemOutputs = clone(this.viewData.strategyItemOutputsCheck)
      this.postData.strategyItemOutputs.forEach(item => {
        item.name = this.postData.code + '_' + item.name
      })
      this.postData.strategyRefVariables = clone(this.viewData.strategyRefVariables)

      this.$confirm('请确认是否保存？').then(async () => {
        try {
          const res = await this.$http.post('/strategy/item', this.postData)
          if (res.code === '200') {
            this.$message.success('操作成功!')
            this.closeDialog()
          } else {
            this.$message.error(res.message)
          }
        } catch (err) {
          console.error(err)
        }
      }).catch(() => {
      })
    }),
    generateExpression () {
      if (this.viewData.putOutHeader.length <= 0) {
        this.$message.error('输出变量不能为空')
        return null
      }
      if (this.viewData.putInHeader.length <= 0) {
        this.$message.error('输入变量不能为空')
        return null
      }
      let expression = ''
      let dataLength = this.viewData.putInTableData.length
      let inLength = this.viewData.putInHeader.length
      let outLength = this.viewData.putOutHeader.length
      for (let i = 0; i < dataLength; i++) {
        let conditions = []
        for (let j = 0; j < inLength; j++) {
          let label = this.viewData.putInHeader[j].label
          let element = this.viewData.putInTableData[i][label]
          if (!element || !element.trim()) {
            this.$message.error(label + '不能为空')
            return null
          }
          conditions.push(`(${element})`)
        }
        let outputs = []
        for (let k = 0; k < outLength; k++) {
          let label = this.viewData.putOutHeader[k].label
          let element = this.viewData.putOutTableData[i][label]
          if (!element || !element.trim()) {
            this.$message.error(label + '不能为空')
            return null
          }
          let output = this.viewData.strategyItemOutputsCheck.find(s => s.name === label && s.dataType === 2)
          let result = output ? element.trim() : (element.match(this.regex) || element.includes('$') ? element.trim() : `"${element.trim()}"`)

          outputs.push(`"${this.decisionTreeForm.code}_${label.trim()}":${result}`)
        }
        expression += `if(${conditions.join(' && ')}) { return {${outputs.join(',')}};} else `
      }
      // 兜底结果
      let outputs = []
      for (let k = 0; k < outLength; k++) {
        let label = this.viewData.putOutHeader[k].label
        let element = this.viewData.putOutTableData[dataLength][label]
        if (!element || !element.trim()) {
          this.$message.error('兜底结果不能为空')
          return null
        }
        let output = this.viewData.strategyItemOutputsCheck.find(s => s.name === label && s.dataType === 2)
        let result = output ? element.trim() : (element.match(this.regex) ? element.trim() : `"${element.trim()}"`)
        outputs.push(`"${this.decisionTreeForm.code}_${label.trim()}":${result}`)
      }
      expression += `{ return {${outputs.join(',')}};}`
      this.postData.expression = expression
      return expression
    },
    addRow () {
      const size = this.viewData.putInTableData.length + 1
      this.$refs.putInTable.insertAt({
        id: size
      }, -1)
      let outIndex = size - 1
      this.$refs.putOutTable.insertAt({
        id: size
      }, outIndex)
      // 设置初始空格
      this.viewData.putInHeader.forEach(a => {
        this.viewData.putInTableData[size - 1][a.label] = ''
      })
      // 设置初始空格
      this.viewData.putOutHeader.forEach(a => {
        this.viewData.putOutTableData[size - 1][a.label] = ''
      })
      // 添加兜底输入框
      if (this.viewData.putInTableData.length === this.viewData.putOutTableData.length) {
        this.viewData.putOutTableData.push(clone(this.viewData.putOutTableData[0]))
      }
    },
    addPutIn (columnName) {
      this.viewData.putInHeader.push({
        label: columnName,
        prop: columnName,
        variable: clone(this.inVariableInfo.targets)
      })
      this.inVisibleDialog = false
    },
    deleteRow (index) {
      this.$refs['putInTable'].removeRow(index)
      this.$refs['putOutTable'].removeRow(index)
      this.updateTargets()
    },
    removeInColumn (column, index) {
      this.viewData.putInHeader.splice(index, 1)
    },
    removeOutColumn (column, index) {
      this.viewData.putOutHeader.splice(index, 1)
      this.viewData.putOutTableData.forEach(a => delete a[column])
      // 删除输出变量
      let outputs = this.viewData.strategyItemOutputsCheck
      for (let i = 0; i < outputs.length; i++) {
        if (outputs[i].name === column) {
          outputs.splice(i, 1)
        }
      }
      this.updateTargets()
    },
    async testExpression () {
      let expression = this.generateExpression()
      if (!expression) {
        return false
      }
      let testData = this.viewData.testData
      for (let key in testData) {
        let testDataValue = testData[key]
        let reg = new RegExp(/^([-+])?\d+(\.\d+)?$/)
        if (reg.test(testDataValue)) {
          testData[key] = Number(testDataValue)
        }
      }
      let jsonStr = JSON.stringify(testData)
      expression = this.replaceEMS(expression)
      try {
        const params = {
          expression: expression,
          env: jsonStr
        }
        const res = await this.$http.post(`/common/expressions/evaluator`, params)
        if (res.code === '200') {
          this.testResult = res.data
          this.$message.success('测试通过!')
          return true
        } else {
          this.$message.error('测试未通过!')
          this.testResult = res.message
        }
      } catch (err) {
        console.error(err)
      }
      return false
    },
    tableRowStyle ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'background: oldlace'
      } else {
        return 'background: #f0f9eb'
      }
    }
  },
  components: {
    'el-editable': Editable,
    'el-editable-column': EditableColumn,
    TributeMention
  }
}
</script>

<style lang="stylus" scoped>
  .decision-table {
  }
  .decision-table >>> .el-input__inner {
    background-color: #f5f7fa !important;
    border-color: #e4e7ed !important;
    color: #c0c4cc !important;
    cursor: not-allowed !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/component/decision-table.vue